<template>
  <el-card class="box-card">
    <a :href="link" class="app-link">{{name}}</a>
    <div class="app-short-desc">{{details}}</div>
  </el-card>
</template>

<script>
export default {
  name: 'AppCard',
  props: ['link', 'name', 'details']
}
</script>
<style scoped>
  .box-card:not(:first-of-type) {
    margin-top: 24px;
  }

  .box-card .app-link {
    text-decoration: none;
    font-family: opificio, hanken;
    font-size: 20px;
    color: #409EFF;
  }

  .box-card .app-short-desc {
    margin-top: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AppCard.vue